{ "compressionlevel":-1,
 "height":14,
 "infinite":false,
 "layers":[
        {
         "draworder":"topdown",
         "id":2,
         "name":"Objects",
         "objects":[
                {
                 "height":32,
                 "id":1,
                 "name":"",
                 "rotation":0,
                 "type":"collider",
                 "visible":true,
                 "width":224,
                 "x":64,
                 "y":192
                }, 
                {
                 "ellipse":true,
                 "height":128,
                 "id":2,
                 "name":"target",
                 "rotation":0,
                 "type":"target",
                 "visible":true,
                 "width":128,
                 "x":416,
                 "y":256
                }, 
                {
                 "height":0,
                 "id":3,
                 "name":"player",
                 "point":true,
                 "rotation":0,
                 "type":"player",
                 "visible":true,
                 "width":0,
                 "x":160,
                 "y":352
                }, 
                {
                 "height":256,
                 "id":4,
                 "name":"",
                 "rotation":0,
                 "type":"collider",
                 "visible":true,
                 "width":32,
                 "x":288,
                 "y":192
                }, 
                {
                 "height":64,
                 "id":5,
                 "name":"",
                 "rotation":0,
                 "type":"collider",
                 "visible":true,
                 "width":32,
                 "x":288,
                 "y":0
                }],
         "opacity":1,
         "type":"objectgroup",
         "visible":true,
         "x":0,
         "y":0
        }],
 "nextlayerid":3,
 "nextobjectid":6,
 "orientation":"orthogonal",
 "properties":[
        {
         "name":"levelName",
         "type":"string",
         "value":"Level 4"
        }, 
        {
         "name":"order",
         "type":"int",
         "value":3
        }],
 "renderorder":"right-down",
 "tiledversion":"1.6.0",
 "tileheight":32,
 "tilesets":[],
 "tilewidth":32,
 "type":"map",
 "version":"1.6",
 "width":20
}